export default __webpack_public_path__ + "static/media/checkbox-vector.d45e5ca4.svg";